import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mainInfoCard"
}
const _hoisted_2 = {
  key: 1,
  class: "routelink"
}
const _hoisted_3 = { class: "ctaLink rte" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "heading" }
const _hoisted_6 = {
  key: 5,
  class: "allRoutes"
}
const _hoisted_7 = {
  key: 0,
  class: "heading"
}
const _hoisted_8 = {
  key: 1,
  class: "filterButtons"
}

import {
  DownloadApp,
} from '@components';
import {
  computed,
  ref,
  watch,
  watchEffect,
} from 'vue';
import { useI18n } from 'vue-i18n';
import sortBy from 'lodash/sortBy';
import { Route } from '../../apiTypes';
import {
  ServiceStatusSearch,
  InfoCard,
  Icon,
  StatusKeyButton,
  RouteItemsList,
  mapRoutes,
  FilterStatusKeyButton,
  Button,
} from '../../index';
import { useServiceStatusStore } from '../../stores';
import { RouteServiceStatus, ServiceStatusType } from '../../types';
import { INFO_CARD_COLOR } from '../../../../constants/info-card-color';
import { smsAlertSignupUrl, mobileAppDownloadUrl } from '../../envVariables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceStatusHome',
  props: {
    isOverlayView: { type: Boolean },
    isMobile: { type: Boolean },
    serviceStatusFilters: {},
    filterModalClickHandler: { type: Function },
    clearServiceStatusFilters: { type: Function },
    statusModalClickHandler: { type: Function },
    selectRouteMapCallback: { type: Function },
    updateRouteMapCallback: { type: Function },
    redirectToServiceIndex: { type: Function },
    searchInputId: {},
    searchInputLabel: {},
    isOffline: { type: Boolean },
    onRefresh: { type: Function }
  },
  emits: ['getSelectedRouteCode', 'getHasSearch', 'getAllRoutes'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const props = __props;

const emit = __emit;

const serviceStatusStore = useServiceStatusStore();
const renderAllRoutes = ref<RouteServiceStatus[]>();
const renderFilteredRoutes = ref<RouteServiceStatus[]>();
const showAllRoutesList = ref(!!renderAllRoutes.value);
const affectedRoutes = ref<RouteServiceStatus[]>();
const showAffectedRoutesList = ref(!!affectedRoutes.value);
const hasSearchResults = ref(false);
const searchResults = ref<RouteServiceStatus[]>();
const showSearchResultsList = ref(!!searchResults.value);
const isLoading = ref<boolean>(false);
const searchInput = ref('');
const resultsText = ref('');
const isRefreshDisabled = ref(false);

const handleRefresh = () => {
  if (props.onRefresh) {
    props.onRefresh();
    isRefreshDisabled.value = true;
    setTimeout(() => {
      isRefreshDisabled.value = false;
    }, 5000);
  }
};

const canShowRoutes = computed(() => (
  !hasSearchResults.value && !props.isOffline && !serviceStatusStore.isServiceStatusError
));

const displayAffectedRoutes = computed(() => (
  (showAffectedRoutesList.value || isLoading.value) && props.isOverlayView && canShowRoutes.value
));

const displayAllRoutes = computed(() => (
  (showAllRoutesList.value || isLoading.value) && !props.isOverlayView && canShowRoutes.value
));

const updateMap = (results) => {
  if (props.updateRouteMapCallback) props.updateRouteMapCallback(results);
};

const searchClickAction = (searchValue) => {
  serviceStatusStore.addRecentSearch(searchValue, props.isMobile);
};

const updateSearchResults = (newSearchResults) => {
  hasSearchResults.value = newSearchResults !== undefined;
  searchResults.value = newSearchResults;
};

const updateSearchInput = (newSearchInput) => {
  searchInput.value = newSearchInput;
};

const mapRenderRoutes = (allRoutes: Route[] | undefined) => {
  const sortRoutes = (routes: Route[] | undefined) =>
    (routes ? sortBy(routes.map(mapRoutes), [(a) => a.destinationName, (a) => a.ports?.[0]?.name || '']) : undefined);

  renderAllRoutes.value = sortRoutes(allRoutes);
  showAllRoutesList.value = !!(renderAllRoutes.value?.length);

  affectedRoutes.value = sortRoutes(serviceStatusStore.getAffectedRoutes);
  showAffectedRoutesList.value = !!(affectedRoutes.value?.length);
};

const itemClickAction = async (serviceArray, index) => {
  const { routeCode } = serviceArray[index];
  emit('getSelectedRouteCode', routeCode);
};

const infoCardDetails = computed(() => {
  let noOfAffectedRoutes;
  let totalRoutes;

  if (serviceStatusStore.isServiceStatusError || serviceStatusStore.isRoutesSuggestionError) {
    return {
      icon: 'warning',
      text: t('Trouble retrieving service'),
      backgroundColor: INFO_CARD_COLOR.white,
      borderColor: INFO_CARD_COLOR.red,
      showRefresh: true,
    };
  }

  if (hasSearchResults.value) {
    const filteredAffectedResultsList = searchResults.value?.filter((item) => item.status !== 'normal');
    noOfAffectedRoutes = filteredAffectedResultsList?.length;
    totalRoutes = searchResults.value?.length;
  } else {
    noOfAffectedRoutes = affectedRoutes.value?.length;
    totalRoutes = renderAllRoutes.value?.length;
  }

  return (noOfAffectedRoutes > 0
    ? {
      icon: 'warning',
      text: t(
        'Number of routes affected text',
        [noOfAffectedRoutes, totalRoutes],
      ),
      backgroundColor: INFO_CARD_COLOR.white,
      borderColor: INFO_CARD_COLOR.red,
    }
    : {
      icon: 'statusNormal',
      text: t('All sailings normal text'),
      backgroundColor: INFO_CARD_COLOR.mint,
      borderColor: INFO_CARD_COLOR.mint,
    });
});

const handleClearFilter = () => {
  if (props.clearServiceStatusFilters) props.clearServiceStatusFilters();
  renderFilteredRoutes.value = undefined;
};

mapRenderRoutes(serviceStatusStore.serviceStatus);

watchEffect(() => {
  isLoading.value = serviceStatusStore.isLoading;
});

watch(() => serviceStatusStore.serviceStatus, (newVal) => {
  mapRenderRoutes(newVal);
});

watch(() => hasSearchResults.value, (newHasSearch) => {
  emit('getHasSearch', newHasSearch);
});

watch(() => searchResults.value, (newResults) => {
  showSearchResultsList.value = newResults !== undefined
  && newResults.length > 0;
});

watch(() => searchInput.value, (newInput) => {
  resultsText.value = t('Results for text', [newInput]);
});

watch(() => renderAllRoutes.value, (newAllRoutes) => {
  emit('getAllRoutes', newAllRoutes);
});

watch(() => props.serviceStatusFilters, (newFilters) => {
  const allRoutes = renderAllRoutes.value;
  if (allRoutes && newFilters) {
    const filteredRoutes = newFilters.flatMap((status) =>
      allRoutes.filter((route) => route.status === status));

    renderFilteredRoutes.value = filteredRoutes;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ServiceStatusSearch), {
      "item-click-action": (array, index) => itemClickAction(array, index),
      "select-route-map-callback": _ctx.selectRouteMapCallback,
      "search-click-action": searchClickAction,
      "search-input-id": _ctx.searchInputId,
      "search-input-label": _ctx.searchInputLabel,
      disabled: _ctx.isOffline,
      "is-loading": isLoading.value,
      onUpdateSearchResults: _cache[0] || (_cache[0] = (searchResults) => updateSearchResults(searchResults)),
      onUpdateSearchInput: _cache[1] || (_cache[1] = (searchInput) => updateSearchInput(searchInput)),
      onUpdateMapRoute: _cache[2] || (_cache[2] = (searchResults) => updateMap(searchResults))
    }, {
      infoCard: _withCtx(() => [
        (!_ctx.isOffline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(InfoCard), {
                "icon-name": infoCardDetails.value.icon,
                text: infoCardDetails.value.text,
                "background-color": infoCardDetails.value.backgroundColor,
                "border-color": infoCardDetails.value.borderColor,
                "is-loading": isLoading.value,
                lg: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.onRefresh && infoCardDetails.value.showRefresh)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        label: _ctx.$t('Refresh'),
                        "aria-label": _ctx.$t('Refresh service status'),
                        outline: true,
                        disabled: isRefreshDisabled.value,
                        "on-click": handleRefresh
                      }, null, 8, ["label", "aria-label", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["icon-name", "text", "background-color", "border-color", "is-loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["item-click-action", "select-route-map-callback", "search-input-id", "search-input-label", "disabled", "is-loading"]),
    (!hasSearchResults.value)
      ? _renderSlot(_ctx.$slots, "myRoutes", { key: 0 })
      : _createCommentVNode("", true),
    (_ctx.isOverlayView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("a", {
              tabindex: "0",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToServiceIndex && _ctx.redirectToServiceIndex(...args))),
              onKeypress: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.redirectToServiceIndex && _ctx.redirectToServiceIndex(...args)), ["enter"]))
            }, _toDisplayString(_ctx.$t('View all routes')), 33)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createBlock(_unref(DownloadApp), {
          key: 2,
          "alert-link": _unref(smsAlertSignupUrl),
          "alert-link-text": _ctx.$t('Download App alert link text'),
          "download-link": _unref(mobileAppDownloadUrl),
          "download-link-text": _ctx.$t('Download App link text'),
          "image-src": require('@images/downloadAppImage.png'),
          "image-alt": _ctx.$t('Download app image alt'),
          title: _ctx.$t('Download App title'),
          text: _ctx.$t('Download App text'),
          class: "showMobile"
        }, null, 8, ["alert-link", "alert-link-text", "download-link", "download-link-text", "image-src", "image-alt", "title", "text"]))
      : _createCommentVNode("", true),
    (displayAffectedRoutes.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["affectedRoutes", {noBorder: _ctx.isOverlayView}])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Affected routes')), 1),
            (!_ctx.isOverlayView)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "closeBtn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showAffectedRoutesList.value = false))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Close')) + " ", 1),
                  _createVNode(_unref(Icon), {
                    "icon-name": "closeBold",
                    sm: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.isOverlayView)
              ? (_openBlock(), _createBlock(_unref(StatusKeyButton), {
                  key: 1,
                  "on-click": _ctx.statusModalClickHandler,
                  class: _normalizeClass({overlayView: _ctx.isOverlayView})
                }, null, 8, ["on-click", "class"]))
              : _createCommentVNode("", true)
          ]),
          (affectedRoutes.value)
            ? (_openBlock(), _createBlock(_unref(RouteItemsList), {
                key: 0,
                "route-items": affectedRoutes.value,
                "is-loading": isLoading.value,
                onGetRouteItemsIndex: _cache[6] || (_cache[6] = (routeItems, index) => itemClickAction(routeItems, index))
              }, null, 8, ["route-items", "is-loading"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (showSearchResultsList.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(["searchResults", {noBorder: _ctx.isOverlayView}])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(resultsText.value), 1),
            (hasSearchResults.value && !_ctx.isOffline)
              ? (_openBlock(), _createBlock(_unref(StatusKeyButton), {
                  key: 0,
                  "on-click": _ctx.statusModalClickHandler
                }, null, 8, ["on-click"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(RouteItemsList), {
            "route-items": searchResults.value,
            "is-loading": isLoading.value,
            onGetRouteItemsIndex: _cache[7] || (_cache[7] = (searchResults, index) => itemClickAction(searchResults, index))
          }, null, 8, ["route-items", "is-loading"])
        ], 2))
      : _createCommentVNode("", true),
    (displayAllRoutes.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('All routes')), 1),
                _createVNode(_unref(StatusKeyButton), {
                  "on-click": _ctx.statusModalClickHandler,
                  class: _normalizeClass({overlayView: _ctx.isOverlayView})
                }, null, 8, ["on-click", "class"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(FilterStatusKeyButton), {
                  filters: _ctx.serviceStatusFilters,
                  "on-click": _ctx.filterModalClickHandler,
                  class: _normalizeClass({overlayView: _ctx.isOverlayView})
                }, null, 8, ["filters", "on-click", "class"]),
                (renderFilteredRoutes.value && renderFilteredRoutes.value.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "clearButton",
                      onClick: handleClearFilter
                    }, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", null, "Clear filter", -1)),
                      _createVNode(_unref(Icon), {
                        "icon-name": "close",
                        sm: true
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createVNode(_unref(RouteItemsList), {
            "route-items": (!renderFilteredRoutes.value || renderFilteredRoutes.value.length === 0)
        ? renderAllRoutes.value
        : renderFilteredRoutes.value,
            "is-loading": isLoading.value,
            onGetRouteItemsIndex: _cache[8] || (_cache[8] = (routeItems, index) => itemClickAction(routeItems, index))
          }, null, 8, ["route-items", "is-loading"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})